import { KeyTextField } from '@prismicio/client';
import { FC } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import InfoPopup from '../FormComponents/FormBody/InfoPopup/InfoPopup';
import styles from './Input.module.scss';

interface Props {
  label?: string;
  type: string;
  id: string;
  placeholder?: string;
  error?: FieldError;
  register: UseFormRegisterReturn;
  isBorrowSumInput?: boolean;
  infoPopupData?: { title: KeyTextField; description: KeyTextField };
  disabled?: boolean;
  maxLength?: number;
  inputMode?: 'numeric' | 'text' | 'email';
}

const Input: FC<Props> = ({
  label,
  type,
  id,
  placeholder,
  error,
  register,
  isBorrowSumInput = false,
  infoPopupData,
  disabled = false,
  maxLength = 200,
  inputMode = 'text',
}) => {
  return (
    <div className={`${styles.fieldWrapper} ${error ? styles.errorField : ''}`}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
          {infoPopupData && <InfoPopup data={infoPopupData} variant="phone" />}
        </label>
      )}
      <div className={styles.inputContainer}>
        <input
          className={`${styles.input} ${isBorrowSumInput ? styles.borrowSumInput : ''}`}
          id={id}
          type={type}
          placeholder={placeholder}
          {...register}
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
        />
        {isBorrowSumInput && <span className={styles.dollar}>$</span>}
      </div>
      {error && <p className={styles.error}>{error.message}</p>}
    </div>
  );
};

export default Input;
